import { HRProvider } from "../../context/HRContext";
import { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import HrSidebar from "./HrSidebar";
import HrTopbar from "./HrTopbar";
import HrDashboardPg from "./HrDashboardPg";
import InternsPg from "./InternsPg";
import EmployeesPg from "./EmployeesPg";
import HrAttendancePg from "./HrAttendancePg";
import HrPayrollPg from "./HrPayrollPg";
import HrReportsPg from "./HrReportsPg";
import AdvancesPg from "./AdvancesPg";
import PerformancePg from "./PerformancePg";
import AnnouncementsPg from "./AnnouncementsPg";
import AuditPg from "./AuditPg";
import AnalyticsPg from "./AnalyticsPg";
import HrCalendarPg from "./HrCalendarPg";
import NotesPg from "./NotesPg";
import BulkPg from "./BulkPg";
import OffboardPg from "./OffboardPg";
import HrSettingsPg from "./HrSettingsPg";
import HrTicketsPg from "./HrTicketsPg";
import HrNotificationsPg from "./HrNotificationsPg";
import HrPoliciesPg from "./HrPoliciesPg";
import HrPeoplePg from "./HrPeoplePg";
import UniversalChat from "../../components/common/UniversalChat";
import { usePermissions } from "../../hooks/usePermissions";
import '../../assets/styles/hr.css';

function HrChatWrapper({ user }) {
  const { canWrite } = usePermissions();
  return <UniversalChat currentUserId={user?.userId} canWrite={canWrite('chat')} allowGroupCreate />;
}

function HrPageView({ a, user, onNav }) {
  switch (a) {
    case "dashboard": return <HrDashboardPg />;
    case "interns": return <InternsPg />;
    case "employees": return <EmployeesPg />;
    case "people": return <HrPeoplePg />;
    case "attendance": return <HrAttendancePg />;
    case "leave": return <HrAttendancePg initialTab="leaves" />;
    case "payroll": return <HrPayrollPg />;
    case "reports": return <HrReportsPg />;
    case "advances": return <AdvancesPg />;
    // case "performance": return <PerformancePg />;
    case "announcements": return <AnnouncementsPg />;
    case "notifications": return <HrNotificationsPg onNavigate={onNav} />;
    case "calendar": return <HrCalendarPg />;
    case "chat": return <HrChatWrapper user={user} />;
    case "tickets": return <HrTicketsPg />;
    case "policies": return <HrPoliciesPg />;
    case "notes": return <NotesPg />;
    case "audit": return <AuditPg />;
    case "bulk": return <BulkPg />;
    case "analytics": return <AnalyticsPg />;
    case "offboarding": return <OffboardPg />;
    case "settings": return <HrSettingsPg />;
    default: return <HrDashboardPg />;
  }
}

function HrDashboardInner({ onLogout }) {
  const { user } = useAuth();
  const [a, setA] = useState("dashboard");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return (
    <div className={`R ${sidebarOpen ? "sb-open" : "sb-collapsed"}`}>
      <div className="SB-hotzone" onMouseEnter={() => setSidebarOpen(true)} />
      <button
        type="button"
        className="SB-peek"
        onMouseEnter={() => setSidebarOpen(true)}
        aria-label={sidebarOpen ? "Hide menu" : "Show menu"}
      >
        {sidebarOpen ? "‹" : "›"}
      </button>
      <HrSidebar
        a={a}
        set={setA}
        onLogout={onLogout}
        user={user}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
      />
      <div className="MW">
        <HrTopbar a={a} onLogout={onLogout} user={user} onNav={setA} />
        <div className="MC" key={a}><HrPageView a={a} user={user} onNav={setA} /></div>
      </div>
    </div>
  );
}
export default function HrDashboard(props) {
  return <HRProvider><HrDashboardInner {...props} /></HRProvider>;
}
